export const inRange = (
    num: number,
    beginNumber: number,
    finalNumber: number,
) =>
    Math.min(beginNumber, finalNumber) <= num &&
    num <= Math.max(beginNumber, finalNumber);
